import { render, staticRenderFns } from "./team.vue?vue&type=template&id=141c13ed&scoped=true&"
import script from "./team.vue?vue&type=script&lang=js&"
export * from "./team.vue?vue&type=script&lang=js&"
import style0 from "./team.vue?vue&type=style&index=0&id=141c13ed&lang=scss&scoped=true&"
import style1 from "./team.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c13ed",
  null
  
)

export default component.exports